import { installBrowserEnvToApp, installBrowserPickersToApp } from "@visactor/vrender-kits/installers/browser";

import { installStandardGraphicsToApp } from "@visactor/vrender-kits/installers/graphics";

import { CanvasPickerContribution } from "@visactor/vrender-kits/picker/contributions/constants";

import { ensureBootstrap, registerStandardLegacyGraphics, registerStandardPipeline, syncLegacyPickersToApp, syncLegacyRenderersToApp } from "./bootstrap-common";

export function bootstrapVRenderSharedBrowserApp(app, envParams) {
    return ensureBootstrap(app, "browser-shared") ? (installBrowserEnvToApp(app, envParams), 
    installStandardGraphicsToApp(app), installBrowserPickersToApp(app), registerStandardLegacyGraphics(), 
    syncLegacyRenderersToApp(app), syncLegacyPickersToApp(app, CanvasPickerContribution), 
    registerStandardPipeline(), app) : app;
}
//# sourceMappingURL=bootstrap-browser.js.map